import { Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../models/session/sessionState";
import { Dialog } from "../../framework/Dialog/Dialog";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { useState } from "react";
import { IRiskPageFilterState } from "../RiskPage/RiskPageUtils";
import { RiskList } from "../RiskList";

interface IRiskTrashBinDialogProp {
    sessionState: ISessionState;
    companyId: string;
    units: IIdTitleNode[];
    onLoadPageData: () => void;
    onClose: () => void;
}

interface IRiskTrashBinDialogState extends IRiskPageFilterState {
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export const RiskTrashBinDialog = (props: IRiskTrashBinDialogProp) => {
    const [state, setState] = useState<IRiskTrashBinDialogState>({
        selectedRiskTypeIds: [],
        selectedUnitIds: [],
        selectedStateIds: [],
        selectedRiskCategoryIds: [],
        selectedRiskProcessIds: [],
        selectedRiskStandardIds: [],
        selectedRiskStakeholderIds: [],
        selectedResidualRiskIds: [],
        selectedRiskTreatmentStateIds: [],
        selectedHandlerUserCodes: [],
        selectedOwners: [],
        sortColumn: "modifyDate",
        sortOrderIsAsc: false,
    });
    
    const handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        setState((old) => ({
            ...old,
            sortColumn,
            sortOrderIsAsc,
        }));
    };

    return (
        <Dialog
            id="riskTrashBinDialog"
            maxWidth="xl"
            maxHeight="100%"
            title={Translations.TrashBin}
            body={
                <>
                    <RiskList
                        filterName={null}
                        sessionState={props.sessionState}
                        dataId="0"
                        canCreateRisks={false}
                        listFilterIsSet={false}
                        units={props.units}
                        selectedRiskTypeIds={state.selectedRiskTypeIds}
                        selectedUnitIds={state.selectedUnitIds}
                        selectedStateIds={state.selectedStateIds}
                        selectedRiskCategoryIds={state.selectedRiskCategoryIds}
                        selectedRiskProcessIds={state.selectedRiskProcessIds}
                        selectedRiskStandardIds={state.selectedRiskStandardIds}
                        selectedRiskStakeholderIds={state.selectedRiskStakeholderIds}
                        selectedResidualRiskIds={state.selectedResidualRiskIds}
                        selectedRiskTreatmentStateIds={state.selectedRiskTreatmentStateIds}
                        selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                        selectedOwners={state.selectedOwners}
                        companyId={props.companyId}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        settingsActions={[]}
                        trashBin={true}
                        showDocumentPreview={false}
                        onOpenFiltersDialog={null}
                        onSetSortData={handleFilterSortData}
                        onLoadPageData={props.onLoadPageData}
                        onOpenTrashBinDialog={null}
                        onChangeShowDocumentPreview={null}
                        onToggleSettingsDialog={null}
                        reportTabs={null}
                    />
                </>
            }
            actions={
                <Box display="flex" justifyContent="end" width="100%">
                    <AppButton variant="outlined" onClick={props.onClose}>{Translations.Close}</AppButton>
                </Box>
            }
            onClose={props.onClose}/>
    );
};